import { Font, Page, Text, View, Document, StyleSheet, Image } from "@react-pdf/renderer";
import moment from "moment";

const STLogo = "data:image/png;base64,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";


Font.register({
    family: 'Murecho',
    fonts: [
        {
            src: '/fonts/murecho/Murecho-Regular.ttf',
            fontWeight: 'normal',
        },
        {
            src: '/fonts/murecho/Murecho-Bold.ttf',
            fontWeight: 'bold',
        },
        {
            src: '/fonts/murecho/Murecho-SemiBold.ttf',
            fontWeight: 600,
        }
    ]
});

// Styles
const styles = StyleSheet.create({
page: {
    fontFamily: "Murecho",
    padding: 25,
    paddingTop: 0,
    fontSize: 11,
    backgroundColor: "#fff",
    paddingLeft: 0,
    paddingRight: 0,
    letterSpacing: 0.3
},
header: {
    marginBottom: 20,
    paddingBottom: 10,
    width: "100%",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "#E5E7EB",
    paddingLeft: 40,
    paddingRight: 40
},
logo: {
    width: 160,
    height: 71.3,
    marginBottom: -20,
    marginTop: -10,
    marginRight: -25
},
title: {
    marginBottom: 0,
    marginTop: 5,
    fontSize: 23,
    textAlign: "left",
    letterSpacing: 1
},
twoColumn: {
    flexDirection: 'row', 
    justifyContent: 'space-between', 
    marginBottom: 20,
    paddingLeft: 40,
    paddingRight: 40,
},
invoiceInfo: {
    marginTop: 12,
    marginBottom: 20,
},
section: {
    marginBottom: 10,
},
row: {
    flexDirection: "row",
    justifyContent: "space-between",
    paddingLeft: 40,
    paddingRight: 40,
},
tableHeader: {
    backgroundColor: "#eeeeee",
    padding: 5,
    fontWeight: "bold",
    marginTop: 5,
    marginLeft: 40,
    marginRight: 40
},
tableRow: {
    padding: 5,
    borderBottom: "1 solid #eeeeee",
},
footer: {
    position: "absolute",
    bottom: 10,
    left: 40,
    right: 40,
    textAlign: "center",
    fontSize: 7,
    color: "#666",
},
labelRow: {
    flexDirection: 'row',
    marginBottom: 1,
},
labelTitle: {
    width: 120, // fixed width for alignment
    fontWeight: 'bold',
},
labelValue: {
    flex: 1,
},
});


// PDF Component
const DownloadInvoice = ({ prop, orderItemDetails, companyInfo }) => {
return (
    <Document>
    <Page size="A4" style={styles.page}>
        
        <View style={styles.header}>
            <Text style={styles.title}>INVOICE</Text>
            <Image src={STLogo} style={styles.logo} />
        </View>


        <View style={styles.twoColumn}>
            <View style={{ width: '48%' }}>
                <Text style={{fontWeight: "bold"}}>Order No.</Text>
                <Text>{prop?.order_unique_id}</Text>
            </View>

            <View style={{ width: '48%', textAlign: 'right' }}>
                <Text style={{fontWeight: "bold"}}>Created At</Text>
                <Text>{moment(prop?.created_at).format("LLL")}</Text>
            </View>
        </View>
        

        <View style={styles.twoColumn}>
            <View style={{ width: '68%' }}>
                <Text style={{fontWeight: "bold"}}>Bill To</Text>
                <Text>
                    {prop?.shipping_co || prop?.customer_info?.customer_name || ""}
                </Text>
                <Text>
                    {prop?.customer_info.customer_email}
                </Text>
                <Text>
                    {prop?.shipping_phone || prop?.customer_info.customer_mobile || ""}
                </Text>

                <Text style={{fontWeight: "bold", marginTop: 5}}>
                    Ship To
                    <span className='pl-1 font-semibold'>{prop?.shipping_co || prop?.customer_info?.customer_name || ""}</span>
                </Text>
                {(prop?.delivery_type === "Online") ? 
                    <Text>Online</Text>
                :
                    <Text>{prop?.shipping_address ?? "-"}</Text>
                }
            </View>

            <View style={{ width: '28%', textAlign: 'right' }}>
                <Text style={{fontWeight: "bold"}}>Sold by</Text>
                <Text>{companyInfo?.name}</Text>

                <Text style={{fontWeight: "bold", marginTop: 3}}>Order Type</Text>
                <Text>{prop?.delivery_type?.toString()?.toUpperCase() ?? "-"}</Text>

                <Text style={{fontWeight: "bold", marginTop: 3}}>Payment Status</Text>
                <Text>{orderItemDetails[0]?.paymentStatus?.toString()?.toUpperCase() ?? "-"}</Text>
            </View>
        </View>


        {/* Table Header */}
        <Text style={{ fontSize: 8, textAlign: "center", marginTop: 5}}>** Prices shown are in BDT (Bangladeshi Taka) **</Text>
        <View style={[styles.row, styles.tableHeader]}>
            <Text style={{ width: "8%", textAlign: "center", marginLeft: -5 }}>Qty </Text>
            <Text style={{ width: "62%"}}>&nbsp;Description</Text>
            <Text style={{ width: "15%", textAlign: "center"}}>&nbsp;Unit Price</Text>
            <Text style={{ width: "15%", textAlign: "right"}}>Amount</Text>
        </View>

        {/* Table Rows */}
        {orderItemDetails.map((data, index) => (
        <View key={index} style={styles.row}>
            <Text style={{ ...styles.tableRow, width: "8%", textAlign: "center", borderLeft: "1 solid #eeeeee", borderRight: "1 solid #eeeeee" }}>
                {data.quantity}
            </Text>

            <Text style={{ ...styles.tableRow, width: "62%", borderRight: "1 solid #eeeeee" }}>
                {data.name}
                
                {/* Addons Title */}
                {data.addons?.map((data2, index2) => (
                    <Text key={index2} style={{ marginRight: 10 }}>
                    {"\n"}{data2?.name + " :"}
                    {data2?.items?.map((data3, index3) => (
                        <Text key={index3} style={{ marginLeft: 10 }}>
                            {" "+ data3?.name}
                        </Text>
                    ))}
                    </Text>
                ))}
            </Text>

            <Text style={{ ...styles.tableRow, width: "15%", textAlign: "center", borderRight: "1 solid #eeeeee" }}>
                {data?.unitPrice}
            </Text>

            <Text style={{ ...styles.tableRow, width: "15%", textAlign: "right", borderRight: "1 solid #eeeeee" }}>
                {data?.unitPrice * data.quantity}

                {/* Addons Price */}
                {data.addons?.map((data2, index2) => (
                <Text key={index2} style={{ marginRight: 10 }}>
                    {"\n"}
                    {data2?.items?.map((data3, index3) => (
                        <Text key={index3} style={{ marginLeft: 10 }}>
                            {data3?.totalPrice}
                        </Text>
                    ))}
                    </Text>
                ))}

            </Text>
        </View>
        ))}

        {/* Total */}
        <View style={[styles.row, { marginTop: 10 }]}>
            <Text style={{ width: "70%" }}>&nbsp;Subtotal</Text>
            <Text style={{ width: "30%", textAlign: "right" }}>{prop?.amount}</Text>
        </View>
        <View style={[styles.row, { marginTop: 0 }]}>
            <Text style={{ width: "70%" }}>&nbsp;Discount (-)</Text>
            <Text style={{ width: "30%", textAlign: "right" }}>{prop?.discount_amount}</Text>
        </View>

        <View style={[styles.row, { marginTop: 7 }]}>
            <Text style={{ width: "70%" }}>&nbsp;Total Amount</Text>
            <Text style={{ width: "30%", fontWeight: "bold", textAlign: "right", marginTop: 0 }}>{prop?.payable_amount}</Text>
        </View>

        <View style={[styles.row, {marginTop: 20, marginLeft: 1}]}>
            <Text style={{fontWeight: "bold"}}>Note:</Text>
        </View>
        <View style={[styles.row, {marginTop: 0, marginLeft: 1}]}>
            <Text style={{textAlign: "left"}}>{prop?.customer_note}</Text>
        </View>

        {/* Footer */}
        <View style={[styles.footer, styles.twoColumn]}>
            <View style={{ width: '50%', marginLeft: -40, marginBottom: -15 }}>
                <Text style={{textAlign: "left"}}>Copyright &copy; {moment().format("YYYY")} ShareTrip. All Rights Reserved.</Text>
            </View>
            <View style={{ width: '50%', marginRight: -40, marginBottom: -15 }}>
                <Text style={{textAlign: "right"}}>Printed on {moment().format("LLL")}</Text>
            </View>
        </View>
    </Page>
    </Document>
);
};

export default DownloadInvoice;
